import Brand from './Brand';
import Creator from './Creator';

const index = {
  Brand,
  Creator,
};

export default index;